/**
 * Get the asset path from Gon (uses Rails asset_path helper to automatically get the correct asset path with fingerprint)
 * @param {string} name - The name of the asset (e.g., 'logo', 'msc-badge', etc.)
 * @returns {string|null} The asset path or null if not found
 */
export const getAssetPath = name => {
  if (typeof gon !== "undefined" && gon.asset_paths && gon.asset_paths[name]) {
    return gon.asset_paths[name]
  }
  return null
}

/**
 * Get multiple asset paths at once
 * @param {string[]} names - Array of asset names
 * @returns {Object} Object with asset names as keys and paths as values
 */
export const getAssetPaths = names => {
  const paths = typeof gon !== "undefined" && gon.asset_paths ? gon.asset_paths : {}
  return names.reduce((acc, name) => {
    acc[name] = paths[name] || null
    return acc
  }, {})
}
